import * as React from 'react';
import { useGetUserSessionQuery } from "../../../apis/UserSession.api";
import { PrimaryUserSession, UserSession } from "../../../types/models/UserSession";
import UserName from "../../../../auth/components/user/UserDetail/UserName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: UserSession;
};

export const UserSessionNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><UserName id={ data?.userId }/>
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const UserSessionName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetUserSessionQuery(PrimaryUserSession.fromId(id))
    return (<UserSessionNameDisplay data={data}/>)
}

export default UserSessionName;
